function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".navlogo-grey-cls-1{fill:#606060;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "navlogo-grey-cls-1",
  points: "33.62 79.96 68.36 79.96 68.36 26.39 33.62 8.31 33.62 16.66 61.88 30.92 61.88 73.52 33.62 73.52 33.62 79.96"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "navlogo-grey-cls-1",
  points: "33.62 73.52 -0.35 73.52 -0.35 19.02 33.62 0.04 33.62 8.31 6.12 23.55 6.12 67.08 33.62 67.08 33.62 73.52"
});

function SvgNavLogoGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogoGrey);
export default __webpack_public_path__ + "static/media/nav-logo-grey.3caad790.svg";
export { ForwardRef as ReactComponent };